// extracted by mini-css-extract-plugin
module.exports = {"container":"_3v9g4dbMu4M9GCjGI-bR1j","heading":"_35GAF9mdycf3xu90ZcN7qq"};